
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

const convertBlobToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      // Extract only the base64 part (remove data:audio/webm;base64, prefix)
      const base64 = result.split(',')[1];
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const uploadAndTranscribeAudio = async (
  audioBlob: Blob,
  onNext: (audioFileUrl?: string, audioTranscription?: string, enrichedData?: any) => void
) => {
  try {
    // Obtenir le token du référent depuis l'URL
    const token = window.location.pathname.split('/').pop();
    const fileName = `audio_${token}_${Date.now()}.webm`;

    console.log('Début upload fichier audio:', fileName);
    
    // Upload vers Supabase Storage avec une meilleure gestion d'erreurs
    const { data: uploadData, error: uploadError } = await supabase.storage
      .from('audio-files')
      .upload(fileName, audioBlob, {
        contentType: 'audio/webm',
        upsert: false
      });

    if (uploadError) {
      console.error('Erreur upload détaillée:', uploadError);
      throw new Error(`Erreur upload: ${uploadError.message}`);
    }

    console.log('Upload réussi:', uploadData);

    // Obtenir l'URL publique du fichier
    const { data: { publicUrl } } = supabase.storage
      .from('audio-files')
      .getPublicUrl(fileName);

    console.log('URL publique générée:', publicUrl);

    // Convertir le blob en base64 pour la transcription
    const base64Audio = await convertBlobToBase64(audioBlob);
    console.log('Audio converti en base64, taille:', base64Audio.length);

    // Appeler la fonction de transcription
    const { data: transcriptionData, error: transcriptionError } = await supabase.functions.invoke('transcribe-audio', {
      body: {
        audioBase64: base64Audio,
        fileName: fileName
      }
    });

    if (transcriptionError) {
      console.error('Erreur transcription:', transcriptionError);
      toast.warning('Upload réussi mais transcription indisponible');
      onNext(publicUrl, 'Transcription non disponible');
      return;
    }

    console.log('Résultat transcription:', transcriptionData);

    if (transcriptionData?.success) {
      toast.success('Audio uploadé et transcrit avec succès !');
      // Passer toutes les données enrichies au composant parent
      onNext(publicUrl, transcriptionData.transcription, transcriptionData);
    } else {
      toast.warning('Upload réussi mais transcription échouée');
      onNext(publicUrl, 'Transcription non disponible');
    }
    
  } catch (_error) {
    console.error('Erreur lors de l\'upload:', _error);
    toast.error(`Erreur lors de l'upload: ${_error.message}`);
    throw _error;
  }
};
